import { useState, useEffect ,useRef} from "react";
import { Modal } from "react-bootstrap";
import Loader from "./Loader";
import { Document, Page, pdfjs } from "react-pdf";

// Set the workerSrc for pdf.js (required for react-pdf)
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const ImagePopup = ({ imageUrl, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [isPdf, setIsPdf] = useState(false);
  const [error, setError] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const scrollRef = useRef(0);

  // Handle successful PDF load
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setLoading(false);
  };
  useEffect(() => {
    if (imageUrl) {
      scrollRef.current = window.scrollY; // Save current scroll position
      document.body.style.position = 'fixed';
      // document.body.style.top = `-${scrollRef.current}px`; // lock at current scroll
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    }
  
    return () => {
      document.body.style.position = '';
      // document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
  
      // window.scrollTo(0, scrollRef.current); // Restore original scroll position
    };
  }, [imageUrl]);

  useEffect(() => {
    if (imageUrl) {
      setLoading(true);
      setError(null);
      const isPdfFile = imageUrl.toLowerCase().endsWith(".pdf");
      setIsPdf(isPdfFile);

      if (!isPdfFile) {
        const img = new Image();
        img.src = imageUrl;
        img.crossOrigin = "anonymous";
        img.onload = () => setLoading(false);
        img.onerror = () => {
          setLoading(false);
          setError("Failed to load image");
        };
      } else {
        fetch(imageUrl, { method: "HEAD", mode: "cors", credentials: "omit" })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error ${response.status}`);
            }
          })
          .catch((err) => {
            console.error("Prefetch Error:", err);
            setLoading(false);
            setError("Failed to fetch PDF: " + err.message);
          });

        const timeout = setTimeout(() => {
          if (loading) {
            console.error("PDF loading timed out");
            setLoading(false);
            setError("PDF loading timed out. Please check the URL or server.");
          }
        },1000);

        return () => clearTimeout(timeout);
      }
    }
  }, [imageUrl]);

  return (
    <>
      {loading ? (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50">
          <Loader />
        </div>
      ) : isPdf ? (
        <div className="fixed inset-0 flex items-center justify-center bg-[#000000a3] z-[99999] overflow-auto">
          <div style={{ maxHeight: "90vh", maxWidth: "90vw", overflow: "auto"}}>
            <Document
              file={{
                url: imageUrl,
                httpHeaders: {},
                withCredentials: false,
              }}
              onLoadSuccess={onDocumentLoadSuccess}
              onLoadError={(err) => {
                setLoading(false);
                setError("Failed to load PDF");
              }}
            >
              {numPages &&
                Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    width={Math.min(800, window.innerWidth * 0.8)}
                  />
                ))}
            </Document>
          </div>
          <button
            className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center bg-white text-black rounded-full shadow-md hover:bg-gray-200 transition"
            onClick={onClose}
          >
            {/* Close Icon */}
            <svg
              className="svg-icon"
              style={{
                height: "28px",
                verticalAlign: "middle",
                fill: "currentColor",
                overflow: "hidden",
              }}
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M704.28672 309.20704l28.95872 28.9792L334.6432 736.78848l-28.95872-28.9792z" fill="#231815" />
              <path d="M341.03296 315.5968l398.60224 398.60224-28.95872 28.95872-398.60224-398.60224z" fill="#231815" />
            </svg>
          </button>
        </div>
      ) : (
        <Modal show={!!imageUrl} onHide={onClose} centered backdrop="static">
          <Modal.Body className="bg-black d-flex justify-content-center align-items-center p-0 relative">
            <button
              className="absolute top-3 right-3 w-10 h-10 flex items-center justify-center bg-white text-black rounded-full shadow-md hover:bg-gray-200 transition"
              onClick={onClose}
            >
              {/* Close Icon */}
              <svg
                className="svg-icon"
                style={{
                  height: "28px",
                  verticalAlign: "middle",
                  fill: "currentColor",
                  overflow: "hidden",
                }}
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M704.28672 309.20704l28.95872 28.9792L334.6432 736.78848l-28.95872-28.9792z" fill="#231815" />
                <path d="M341.03296 315.5968l398.60224 398.60224-28.95872 28.95872-398.60224-398.60224z" fill="#231815" />
              </svg>
            </button>

            <img
              crossOrigin="anonymous"
              src={imageUrl}
              alt="Preview"
              className="img-fluid mw-100 mh-100 object-fit-contain"
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default ImagePopup;
